import type { FunctionComponent } from "react";

import LoadingSpinner from "~/components/LoadingSpinners/LoadingSpinner";


const TableBodyLoader: FunctionComponent = () => {
	return <tr>
		<td colSpan={100}>
			<div className="flex w-full items-center justify-center bg-inherit px-3 py-4"><LoadingSpinner /></div>
		</td>
	</tr>;
};

export default TableBodyLoader;